module.exports = __webpack_public_path__ + "static/img/3.2cba77a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/common/document/4/3.png
// module id = 6bXy
// module chunks = 1